export const userType = {
    "filter": {
      "title": "Tipos de usuario",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar tipos de usuarios",
        "firstSelect": "Estatus de tipos de usuario"
      }
    },
    "informationCard": {
      "create": {
        "title": "Nuevo tipo de usuario"
      },
      "edit": {
        "title": "Editar tipo de usuario"
      },
      "buttons": {
        "add": "Agregar tipo",
        "update": "Actualizar tipo",
        "cancel": "Cancelar",
        "edit": "Editar tipo"
      }
    },
    "modal": {
      "delete": {
        "title": "¿Está seguro que desea eliminar un tipo de usuario?",
        "description": "Al eliminar un tipo de usuario, se borrará de la lista",
        "success": {
          "title": "El tipo de usuario se eliminó exitosamente",
          "description": ""
        },
        "error": {
          "title": "Hay un error y el tipo de usuario no puede ser eliminado",
          "description": ""
        }
      }
    }
  }